<template>
	
	<article class="blog-article-tile columns is-gapless">
		<div class="column is-5 flex-middle">
			<a :href="podcast.url"><img class="featured" :src="podcast.mediaUrl"/></a>
		</div>
		<div class="column">
			<div class="details">
				<h3 class="title is-3">
					<a :href="podcast.url">{{podcast.title}}</a>
				</h3>
				<p>{{podcast.caption}}</p>
				<div class="author">
					<div class="avatar is-rounded is-3">
						<img :src="podcast.author.avatarUrl"/>
					</div>
					<div class="attribution">
						<a class="name is-primary" :href="'/take-5-daily?author=' + podcast.author.id">{{podcast.author.name}}</a>
						<span class="affiliation">{{podcast.author.affiliation}}</span>
					</div>
				</div>
			</div>
		</div>
	</article>
	
</template>
	
<script>
	export default {
		name: "PodcastTile",
		props: ["podcast"],
	}
</script>

<style lang="scss" scoped>
	.blog-article-tile {
		margin-bottom: 1.5rem !important;
	}
</style>